import { lazy } from 'react';

const AgrementDateContainer = lazy(() => import('../containers/AgrementDateContainer'));

const AgrementDateRoute = () => <AgrementDateContainer />;

export default AgrementDateRoute;
